import React from 'react';
import { OrganisationMasterScreen } from '../organisation/OrganisationMasterScreen';
import { entityDefinition } from '../organisation/organisationDefinitions';

interface Props { moduleIcon?: string; tabId?: string; moduleName?: string }

/** Entities of a tenant — the organisation master (standard §7.5). */
const EntityMasterScreen: React.FC<Props> = (props) => (
  <OrganisationMasterScreen definition={entityDefinition} {...props} />
);

export default EntityMasterScreen;
